import { useKeenSlider } from 'keen-slider/react'
import React, { useCallback, useState } from 'react'
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import FavoriteCourseCard from '../FavoriteCourseCard'
import { ButtonWrapper, Container } from './styles'

interface FavoriteCoursesListProps {
  favoriteCourses: any[] // @TODO: fazer o type
  subscriptionId: string
}

const FavoriteCoursesList: React.FC<FavoriteCoursesListProps> = ({
  favoriteCourses,
  subscriptionId,
}) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0)
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    mode: 'snap',
    loop: favoriteCourses.length > Math.floor(window.innerWidth / 400),
    breakpoints: {
      '(max-width: 500px)': {
        slides: { perView: 1, spacing: 5 },
      },
      '(min-width: 600px)': {
        slides: { perView: 3, spacing: 2 },
      },
    },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel)
    },
  })

  const ArrowLeft = useCallback(({ disabled, onClick }) => {
    const disabeld = disabled ? ' arrow--disabled' : ''
    return (
      <button className={'arrow arrow--left' + disabeld} onClick={onClick}>
        <BsArrowLeftShort size={27} />
      </button>
    )
  }, [])

  const ArrowRight = useCallback(({ disabled, onClick }) => {
    const disabeld = disabled ? ' arrow--disabled' : ''
    return (
      <button className={'arrow arrow--right' + disabeld} onClick={onClick}>
        <BsArrowRightShort size={27} />
      </button>
    )
  }, [])

  return (
    <Container>
      <h2 className="title">Favoritos</h2>
      <div>
        <div ref={sliderRef} className="keen-slider cards">
          {favoriteCourses.length ? (
            favoriteCourses.map((item, idx) => (
              <div className={`keen-slider__slide number-slide${idx}`} key={`card-${item._id}`}>
                <FavoriteCourseCard
                  _id={item._id}
                  name={item.name}
                  icon={item.icon}
                  numberOfModules={item.numberOfModules}
                  subscriptionId={subscriptionId}
                />
              </div>
            ))
          ) : (
            <div style={{ marginLeft: '1rem' }}>
              <h4>Nenhum curso favorito cadastrado</h4>
            </div>
          )}
        </div>
        {favoriteCourses.length
          ? favoriteCourses.length > Math.floor(window.innerWidth / 400) && (
              <ButtonWrapper>
                <ArrowLeft
                  onClick={(e: any) => e.stopPropagation() || slider.current?.prev()}
                  disabled={currentSlide === 0}
                />
                <ArrowRight
                  onClick={(e: any) => e.stopPropagation() || slider.current?.next()}
                  disabled={
                    currentSlide && currentSlide === slider.current?.track.details.slides.length - 1
                  }
                />
              </ButtonWrapper>
            )
          : ''}
      </div>
    </Container>
  )
}

export default FavoriteCoursesList
